module.exports = __webpack_public_path__ + "static/img/main_banner1.c80ca7a9.png";